import axios from "axios";
import api from "./api";

let _bdcFailed = false; // bigdatacloud rejects some networks with 400 — skip straight to our fallback

async function bigDataCloud(lat, lon) {
  const { data } = await axios.get("https://api.bigdatacloud.net/data/reverse-geocode-client", {
    params: { latitude: +lat, longitude: +lon, localityLanguage: "en" },
  });
  if (!data.city && !data.locality && !data.countryName) throw new Error("empty result");
  // county/district: the administrative entry between state (adminLevel 4) and city
  const admin = data.localityInfo?.administrative || [];
  const district = admin.find((a) => a.adminLevel >= 5 && a.adminLevel <= 8
    && a.name !== data.principalSubdivision && a.name !== data.city)?.name;
  return {
    city: data.city || data.locality || data.principalSubdivision,
    district: district || undefined,
    state: data.principalSubdivision,
    state_code: data.principalSubdivisionCode,
    country: data.countryName,
    country_code: data.countryCode,
    lat, lon,
  };
}

async function localReverse(lat, lon) {
  const { data } = await api.get("/geo/reverse", { params: { lat: +lat, lon: +lon } });
  if (!data.found) throw new Error("reverse geocode unavailable");
  return {
    city: data.city,
    district: data.district || undefined,
    state: data.state,
    state_code: undefined,
    country: data.country,
    country_code: data.country_code,
    lat, lon,
  };
}

export async function reverseGeocode(lat, lon) {
  if (lat == null || lon == null || Number.isNaN(+lat) || Number.isNaN(+lon)) {
    throw new Error("reverse geocode unavailable");
  }
  if (!_bdcFailed) {
    try {
      return await bigDataCloud(lat, lon);
    } catch {
      _bdcFailed = true; // remember for the session — fall through to our own index
    }
  }
  return localReverse(lat, lon);
}

export async function geocode(name) {
  if (!name || name.trim().length < 2) return [];
  const { data } = await axios.get("https://geocoding-api.open-meteo.com/v1/search", {
    params: { name: name.trim(), count: 6, language: "en", format: "json" },
  });
  return (data.results || []).map((r) => ({
    name: r.name,
    country: r.country,
    country_code: r.country_code,
    admin1: r.admin1,
    lat: r.latitude,
    lon: r.longitude,
    timezone: r.timezone,
  }));
}
